import React from 'react';

import { Route, useRouteMatch } from 'react-router-dom';

import { AddUsers } from './AddUsers';
import { AdminTabs } from '../../config/adminSettingsConfig';
import ApiKeys from '../../SettingsPanels/ApiKeys';
import AuthSettings from '../../SettingsPanels/AuthSettings';
import FeaturesSettings from '../../SettingsPanels/FeaturesSettings';
import GeneralSettings from '../../SettingsPanels/GeneralSettings';
import Networking from '../../SettingsPanels/Networking';
import RecordingsTab from '../../SettingsPanels/RecordingsTab';
import Sso from '../../SettingsPanels/Sso';
import SuperAdmin from '../../SettingsPanels/SuperAdmin';
import TerminologySettings from '../../SettingsPanels/TerminologySettings';
import UserAdmin from '../../SettingsPanels/UsersAdmin';
import KeyCreate from '../AdminApiKeys/KeyCreate';
import KeyEdit from '../AdminApiKeys/KeyEdit';
import IntegrationCreate from '../AdminIntegrations/IntegrationCreate';
import IntegrationEdit from '../AdminIntegrations/IntegrationEdit';
import IntegrationList from '../AdminIntegrations/IntegrationList';
import SsoUpsert from '../AdminSso/SsoUpsert';
import { ClassesRoutes } from '../Classes/ClassesRoutes';

const UserAdminRoutes = () => {
    const { path } = useRouteMatch();

    return (
        <>
            <Route path={`${path}${AdminTabs.General}`} component={GeneralSettings} />
            <Route path={`${path}${AdminTabs.Features}`} component={FeaturesSettings} />
            <Route path={`${path}${AdminTabs.Terminology}`} component={TerminologySettings} />
            <Route path={`${path}${AdminTabs.Auth}`} component={AuthSettings} />
            <Route path={`${path}${AdminTabs.Classes}`} component={ClassesRoutes} />
            <Route exact path={`${path}${AdminTabs.Users}`} component={UserAdmin} />
            <Route path={`${path}${AdminTabs.Users}/add`} component={AddUsers} />
            <Route exact path={`${path}${AdminTabs.Sso}`} component={Sso} />
            <Route exact path={`${path}${AdminTabs.Sso}/create`} component={SsoUpsert} />
            <Route exact path={`${path}${AdminTabs.Sso}/edit/:idpId`} component={SsoUpsert} />
            <Route exact path={`${path}${AdminTabs.ApiKeys}`} component={ApiKeys} />
            <Route exact path={`${path}${AdminTabs.ApiKeys}/create`} component={KeyCreate} />
            <Route exact path={`${path}${AdminTabs.ApiKeys}/edit`} component={KeyEdit} />
            <Route exact path={`${path}${AdminTabs.Integrations}`} component={IntegrationList} />
            <Route path={`${path}${AdminTabs.Integrations}/create`} component={IntegrationCreate} />
            <Route exact path={`${path}${AdminTabs.Integrations}/edit/:integration`} component={IntegrationEdit} />
            <Route path={`${path}${AdminTabs.Networking}`} component={Networking} />
            <Route path={`${path}${AdminTabs.SuperAdmin}`} component={SuperAdmin} />
            <Route path={`${path}${AdminTabs.RecordingsTab}`} component={RecordingsTab} />
        </>
    );
};

export default UserAdminRoutes;
